import React, { FC } from 'react';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface FormInputSwitchProps {
  name: string;
  label?: string;
  isDisabled?: boolean;
  handleChange: (isChecked: boolean) => void;
  setErrors?: () => void;
}

export const FormInputSwitch: FC<FormInputSwitchProps> = ({
  name = '',
  label = '',
  isDisabled = false,
  handleChange = () => {
    return false;
  },
  setErrors = () => {
    return false;
  },
}) => {
  const { control } = useFormContext();
  const { t } = useTranslation();
  return (
    <FormControlLabel
      className="input input__switch"
      control={
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <div className="input__switch__toggle">
                <span className="input__switch__toggle__status">
                  {value ? t('accountSettings.switchToggleOn') : t('accountSettings.switchToggleOff')}
                </span>
                <Box
                  onClick={() => {
                    if (isDisabled) {
                      setErrors();
                    }
                  }}
                >
                  <Switch
                    onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                      onChange(event, checked);
                      handleChange(checked);
                    }}
                    disabled={isDisabled}
                    checked={!!value}
                  />
                </Box>
              </div>
            );
          }}
        />
      }
      label={label || ''}
    />
  );
};
